import apiInstance from "../Api/ApiInstance";

export async function referralHistoryService(ip, referralCode) {
  return await apiInstance.post(`api/nexus-main/referral-history`, {
    ip,
    referralCode,
  });
}
